module.exports = __webpack_public_path__ + "img/logo Original.129c1259.png";